// extracted by mini-css-extract-plugin
export var chevron = "_ox-1";
export var clickable = "_ox-0";
export var ruleRow = "_ox-2";